import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from "axios";
import './style.css';
import { ReactMic } from 'react-mic';
import NoraZoom from "../../images/nora-zoom.png";
import VideoTimer from "../../images/nora-timer.png";
import { Oval } from 'react-loader-spinner'; 
import { AssemblyAI } from 'assemblyai';
import ErrorIcon from "../../images/error-icon.png";
import InterviewCard1 from "../../images/interviewCard1.png";
import InterviewCard2 from "../../images/interviewCard2.png";
import InterviewCard3 from "../../images/interviewCard3.png";
import InterviewCard4 from "../../images/interviewCard4.png";
import InterviewCard5 from "../../images/interviewCard5.png";
import NoraAILogo from "../../images/noraAILogo.png";
import * as Sentry from '@sentry/react';
import { useMediaQuery } from '@mui/material';
import { franc } from 'franc';
import COMMODORE_LOGO from "../../images/homepage/commodore_partners_logo.png";
import CheckCircle from "../../images/checkCircleNora.png"; 

function DatabaseVettingCompletedScreen() {
  return (
    <div className="completionScreen">
      <div className="completion-content">
        <img src={CheckCircle} alt="Completion Check" className="nora-completion-icon" />

        <div className="nora-success-title">
            <h1> Your meeting with our AI Recruiter is complete! </h1>
            <p> Thank you for taking the time to chat with us. We'll be in touch if any relevant opportunities arise that match your preferences <br />  <br /> You may now exit out of this browser. </p>
        </div>
      </div>
    </div>
  );
}

function DatabaseVettingScreen() {
  const { candidateToInterviewId } = useParams(); // Extract candidateToInterviewId from the URL
  const [candidateInfo, setCandidateInfo] = useState(null);
  const [started, setStarted] = useState(false);
  const [finished, setFinished] = useState(false);
  const [history, setHistory] = useState([]);
  const [record, setRecord] = useState(false);
  const [isVideoOn, setIsVideoOn] = useState(false);
  const [time, setTime] = useState(0);
  const videoRef = useRef(null);
  const messageEndRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isNoraSpeaking, setIsNoraSpeaking] = useState(false);
  const [isInterviewDone, setInterviewDone] = useState(false);
  const [aiResponse, setAiResponse] = useState('');
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [feedbackLoading, setFeedbackLoading] = useState(false);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const recordedChunksRef = useRef([]); // Keep immediate access to chunks for fallback
  const audioContextRef = useRef(null);
  const audioDestinationRef = useRef(null);
  const [uploadId, setUploadId] = useState(null);
  const [showEndModal, setShowEndModal] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');
  const videoMediaRecorderRef = useRef(null);




  const [multipartSession, setMultipartSession] = useState({
    uploadId: null,
    fileName: null,
    bucketName: null,
    key: null,
    candidateId: null,
    uploadedParts: [],
    failedParts: [],
    totalParts: 0,
    isInitialized: false
  });
  
  const multipartSessionRef = useRef({
    uploadId: null,
    fileName: null,
    bucketName: null,
    key: null,
    candidateId: null,
    uploadedParts: [],
    failedParts: [],
    totalParts: 0,
    isInitialized: false
  });
  
  // Simple array to store ALL uploaded parts (much simpler than Map/Set)
  const allUploadedPartsRef = useRef([]); // [{partNumber, ETag}, ...]
  
  const partNumberRef = useRef(0);
  const pendingUploadsRef = useRef(new Set()); // Track which uploads are still in progress

  const client = new AssemblyAI({
    apiKey: "d1ed33af12ac4d478785ac40bb4599a7"
  });

   useEffect(() => {
      console.log("aiResponse: ", aiResponse);
    }, [aiResponse]);


  useEffect(() => {
    const fetchCandidateInfo = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_GET_INTERVIEW_STARTED_DATA, {
          params: { candidateToInterviewId },
          headers: {
            'Content-Type': 'application/json',
          },
        });
        setCandidateInfo(response.data);
      } catch (error) {
        console.error("Failed to fetch candidate information", error);
        
        Sentry.captureException(error, {
          extra: {
            message: "Failed to fetch candidate information",
            candidateToInterviewId,
            endpoint: process.env.REACT_APP_GET_INTERVIEW_STARTED_DATA,
            errorDetails: error.response?.data || error.message
          },
        });
      } finally {
        setLoading(false); // Stop loading when data is fetched
      }
    };

    fetchCandidateInfo();
  }, [candidateToInterviewId]);

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      window.history.pushState(null, null, window.location.href);
      alert("You cannot go back during the interview.");
    };
  
    window.history.pushState(null, null, window.location.href); // Add initial state
    window.addEventListener("popstate", handlePopState);
  
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "Are you sure you want to leave? Your interview progress will be lost.";
    };
  
    window.addEventListener("beforeunload", handleBeforeUnload);
  
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    // Change body style for mockInterviewerZoom
    document.body.style.backgroundColor = "#F7F7F7";
    
    // Cleanup function to reset styles when component is unmounted or when navigating away
    return () => {
      document.body.style.backgroundColor = "#203546";
    };
  }, []);

  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [history]);

  useEffect(() => {
    // console.log("aiResponse: ", aiResponse);
  }, [aiResponse]);

  useEffect(() => {
    // Check if the browser supports the required codec
    const checkCodecSupport = () => {
        if (!MediaRecorder.isTypeSupported('video/webm;codecs=vp8,opus')) {
            console.error('Browser does not support required video codec');
        }
    };
    
    checkCodecSupport();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prevTime => prevTime + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };

  const initializeMultipartUpload = async () => {
    try {
      const formData = new FormData();
      formData.append('candidateToInterviewId', candidateToInterviewId);
      formData.append('contentType', 'video/webm');

      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/initializeMultipartUpload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const session = response.data;
      const newSession = {
        uploadId: session.uploadId,
        fileName: session.fileName,
        bucketName: session.bucketName,
        key: session.key,
        candidateId: session.candidateId,
        uploadedParts: [],
        failedParts: [],
        totalParts: 0,
        isInitialized: true
      };
      
      setMultipartSession(newSession);
      multipartSessionRef.current = newSession;

      // Reset arrays and counters
      allUploadedPartsRef.current = [];
      partNumberRef.current = 0;
      pendingUploadsRef.current.clear();
      recordedChunksRef.current = [];

      return session;
    } catch (error) {
      console.error('Failed to initialize multipart upload:', error);
      throw error;
    }
  };

  const uploadChunkToS3 = async (chunkBlob, partNumber) => {
    pendingUploadsRef.current.add(partNumber);
    
    try {
      const currentSession = multipartSessionRef.current;
      
      if (!currentSession.isInitialized || !currentSession.uploadId) {
        pendingUploadsRef.current.delete(partNumber);
        return;
      }

      const urlFormData = new FormData();
      urlFormData.append('uploadId', currentSession.uploadId);
      urlFormData.append('fileName', currentSession.fileName);
      urlFormData.append('partNumber', partNumber);
      urlFormData.append('contentType', 'video/webm');

      const urlResponse = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/getMultipartUploadUrl`, urlFormData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const { uploadUrl } = urlResponse.data;

      const uploadResponse = await axios.put(uploadUrl, chunkBlob, {
        headers: { 'Content-Type': 'video/webm' },
        timeout: 60000,
      });

      // Get ETag from response headers
      let etag = uploadResponse.headers.etag || 
                 uploadResponse.headers.ETag || 
                 uploadResponse.headers['etag'] || 
                 uploadResponse.headers['ETag'];

      if (!etag) {
        throw new Error(`No ETag returned for part ${partNumber}`);
      }

      const newPart = { partNumber: partNumber, ETag: etag }; 
      
      // Add to uploaded parts array
      allUploadedPartsRef.current.push(newPart);
      
      // Mark upload as complete
      pendingUploadsRef.current.delete(partNumber);

      return { partNumber: partNumber, ETag: etag };
    } catch (error) {
      console.error(`Failed to upload chunk ${partNumber}:`, error);
      pendingUploadsRef.current.delete(partNumber);
      
      throw error;
    }
  };

  const completeMultipartUpload = async () => {
    try {
      const currentSession = multipartSessionRef.current;
      const uploadedParts = allUploadedPartsRef.current;
      
      if (!currentSession.isInitialized || uploadedParts.length === 0) {
        console.warn('MULTIPART: No parts to complete or session not initialized');
        return null;
      }

      // Validate that all parts have valid ETags
      const invalidParts = uploadedParts.filter(part => !part.ETag || part.ETag === 'undefined');
      if (invalidParts.length > 0) {
        throw new Error(`${invalidParts.length} parts have invalid ETags`);
      }

      // Sort parts by part number to ensure correct order
      const sortedParts = uploadedParts.sort((a, b) => a.partNumber - b.partNumber);

      const formData = new FormData();
      formData.append('uploadId', currentSession.uploadId);
      formData.append('fileName', currentSession.fileName);
      formData.append('candidateToInterviewId', candidateToInterviewId);
      formData.append('partsData', JSON.stringify(sortedParts));

      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/completeMultipartUpload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      return response.data.finalUrl;
    } catch (error) {
      console.error('Failed to complete multipart upload:', error.response?.data || error.message);
      
      const currentSession = multipartSessionRef.current;
      const uploadedParts = allUploadedPartsRef.current;
      
      Sentry.captureException(error, {
        extra: {
          message: "Multipart upload completion failed",
          candidateToInterviewId: candidateToInterviewId,
          uploadId: currentSession?.uploadId || 'unknown',
          fileName: currentSession?.fileName || 'unknown',
          totalParts: uploadedParts?.length || 0,
          uploadedParts: uploadedParts?.map(p => ({ partNumber: p.partNumber, hasETag: !!p.ETag })) || [],
          errorDetails: error.response?.data || error.message,
          uploadMethod: 'multipart_completion'
        },
      });
      
      throw error;
    }
  };



  const fallbackToTraditionalUpload = async (reason) => {
    try {
      if (recordedChunksRef.current.length === 0) {
        return;
      }
      
      // Combine all recorded chunks into a single video Blob
      const videoBlob = new Blob(recordedChunksRef.current, { type: 'video/webm' });

      const urlFormData = new FormData();
      urlFormData.append('candidateToInterviewId', candidateToInterviewId);
      urlFormData.append('mimeType', 'video/webm');

      const urlResponse = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/getPresignedUploadUrl`, urlFormData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 30000
      });

      const { uploadUrl, finalUrl } = urlResponse.data;

      // Upload the blob to S3
      await axios.put(uploadUrl, videoBlob, {
        headers: { 'Content-Type': 'video/webm' },
        timeout: 300000
      });

      await updateCandidateVideoUrl(finalUrl);
      
      setRecordedChunks([]);
      recordedChunksRef.current = [];
      
    } catch (error) {
      console.error(`Fallback upload failed:`, error.message);
      
      Sentry.captureException(error, {
        extra: {
          message: "Traditional upload fallback failed",
          candidateToInterviewId: candidateToInterviewId,
          fallbackReason: reason,
          videoSize: recordedChunksRef.current.length > 0 ? 
            (recordedChunksRef.current.reduce((total, chunk) => total + chunk.size, 0) / 1024 / 1024).toFixed(2) + 'MB' : 'unknown',
          totalChunks: recordedChunksRef.current.length,
          errorDetails: error.response?.data || error.message,
          uploadMethod: 'traditional_fallback'
        },
      });
    }
  };

  const updateCandidateVideoUrl = async (finalUrl) => {
    try {
      let mp4Url = finalUrl;
      if (!mp4Url.includes("processed-videos/")) {
        mp4Url = mp4Url.replace("interview-video-", "processed-videos/interview-video-");
      }
      mp4Url = mp4Url.replace(".webm", "_converted.mp4");

      const confirmFormData = new FormData();
      confirmFormData.append('candidateToInterviewId', candidateToInterviewId);
      confirmFormData.append('fileUrl', mp4Url);

      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/confirmVideoUpload`, confirmFormData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      return response.data;
    } catch (error) {
      console.error('Failed to update database:', error);
      throw error;
    }
  };

   // Helper function to map language names to AssemblyAI language codes
   const getAssemblyAILanguageCode = (languageName) => {
    if (!languageName) return 'en'; // Default to English

    const languageMap = {
      'English': 'en',
      'Hindi': 'hi',
      'Spanish': 'es',
      'French': 'fr',
    };

    return languageMap[languageName] || 'en'; // Default to English if language not found
  };

  const getGoogleTTSLanguageCode = (languageName) => {
    if (!languageName) return 'en-US'; // Default to English

    const languageMap = {
      'English': 'en-US',
      'Hindi': 'hi-IN',
      'Spanish': 'es-ES',
      'French': 'fr-FR',
    };

    return languageMap[languageName] || 'en-US'; // Default to English if language not found
  };

  // Function to detect language and get appropriate TTS language code
  function detectLanguageForTTS(text) {
    // Detect language using franc (returns ISO 639-3 code)
    const detectedLangISO3 = franc(text, {
      minLength: 10,
      whitelist: ['eng', 'fra']
    });
    
    // Map to Google TTS language codes
    switch (detectedLangISO3) {
      case 'fra':
        return 'fr-FR';
      case 'eng':
      default:
        return 'en-US';
    }
  }

  const startRecording = () => {
    setRecord(true);
  };

  const stopRecording = () => {
    setRecord(false);
  };

  const handleConfirmEnd = () => {
    setShowEndModal(false);
    handleEndInterview(); // Trigger end interview logic
  };
  
  const handleCancelEnd = () => {
    setShowEndModal(false); // Close the modal
  };

  const handleEndInterviewClick = () => {
    if (history.some((msg) => msg.message.includes("End of the interview"))) {
      handleEndInterview(); 
    } else {
      setShowEndModal(true); 
    }
  };

  //This will retry the API twice if it fails for some reason in the first time
  const retryRequest = async (fn, retries = 2, interval = 1000) => {
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        setHasError(false);
        return await fn();
      } catch (error) {
        if (attempt < retries - 1) {
          await new Promise(resolve => setTimeout(resolve, interval));
        } else {
          setHasError(true);

          Sentry.captureException(error, {
            extra: {
              message: "Retry function failed",
              candidateToInterviewId: candidateToInterviewId,
              retriesAttempted: retries,
              intervalBetweenRetries: interval,
              lastError: error.message, // Include the last error message
            },
          });
          throw error;
        }
      }
    }
  };

  const onStop = (recordedBlob) => {
    const reader = new FileReader();
    reader.readAsDataURL(recordedBlob.blob);
    setHasError(false);
    assemblySpeechToText(recordedBlob.blob); 
  };

  const assemblySpeechToText = async (audioBlob) => {
    setIsLoading(true);

    try {
      // Check if bilingual mode is enabled
      const isBilingualMode = candidateInfo?.companyInterview?.bilingualLanguage === true;
      
      let transcript;
      
      if (isBilingualMode) {
        // Use language detection in bilingual mode
        transcript = await retryRequest(() =>
          client.transcripts.transcribe({
            audio: audioBlob,
            language_detection: true,
          })
        );
        
        // Store the detected language for later use
        if (transcript.detected_language) {
          console.log(`AssemblyAI detected language: ${transcript.detected_language}`);
        }
      } else {
        // Standard monolingual mode - use configured language
        const languageCode = getAssemblyAILanguageCode(candidateInfo?.companyInterview?.interviewLanguage);
        
        transcript = await retryRequest(() =>
          client.transcripts.transcribe({
            audio: audioBlob,
            language_code: languageCode
          })
        );
      }

      if (transcript.status === 'error') {
        console.error("Error transcribing audio", transcript.error);

        // Capture the error in Sentry
        Sentry.captureMessage("Assembly AI STT failed", {
          extra: {
            audioBlobSize: audioBlob.size,
            audioBlobType: audioBlob.type,
            errorDetails: transcript.error,
            candidateToInterviewId: candidateToInterviewId,
          },
        });        

        setHasError(true);
        setIsLoading(false);
        return;
      }

      handleSendMessage(transcript.text);
    } catch (error) {
      setHasError(true);
      console.error("Speech to text processing failed:", error);
      setIsLoading(false);
    }
  };

  const toggleVideo = async () => {
    if (isVideoOn) {
      // Stop all active tracks if video is turned off
      if (videoRef.current && videoRef.current.srcObject) {
        const stream = videoRef.current.srcObject;
        stream.getTracks().forEach((track) => track.stop());
        videoRef.current.srcObject = null;
      }

      // Clean up the audio context
      if (audioContextRef.current) {
        audioContextRef.current.close();
      }

      // Stop video recording
      if (videoMediaRecorderRef.current && videoMediaRecorderRef.current.state !== 'inactive') {
        videoMediaRecorderRef.current.stop();
      }
    } else {
      try {
        // Create an audio context for mixing
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        audioDestinationRef.current = audioContextRef.current.createMediaStreamDestination();

        // Get user media (audio and video)
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });

        // Set video stream for display
        if (videoRef.current) {
          videoRef.current.srcObject = stream; // Display video
        }

        // Extract user's audio track for mixing
        const userAudioTrack = stream.getAudioTracks()[0];
        const userAudioSource = audioContextRef.current.createMediaStreamSource(new MediaStream([userAudioTrack]));

        // Connect the user's audio to the mixed audio destination
        userAudioSource.connect(audioDestinationRef.current);

        // Create combined stream for video recording (video + mixed audio)
        const videoTrack = stream.getVideoTracks()[0];
        const mixedAudioTrack = audioDestinationRef.current.stream.getAudioTracks()[0];
        const combinedStream = new MediaStream([videoTrack, mixedAudioTrack]);

        // Create MediaRecorder for video recording
        const mimeType = MediaRecorder.isTypeSupported("video/webm;codecs=vp8,opus")
          ? "video/webm;codecs=vp8,opus"
          : MediaRecorder.isTypeSupported("video/webm")
          ? "video/webm"
          : ""; // Fallback for unsupported browsers

        if (!mimeType) {
          throw new Error("Your browser does not support any compatible MIME types for recording.");
        }

        const mediaRecorder = new MediaRecorder(combinedStream, {
          mimeType: mimeType,
          videoBitsPerSecond: 2500000, // 2.5 Mbps for good video quality
          audioBitsPerSecond: 128000, // 128 kbps for audio quality
        });

        mediaRecorder.ondataavailable = async (e) => {
          if (e.data && e.data.size > 0) {
            partNumberRef.current += 1;
            const currentPartNumber = partNumberRef.current;
            
            setRecordedChunks((prev) => [...prev, e.data]);
            recordedChunksRef.current.push(e.data);
            
            // Upload chunk immediately
            uploadChunkToS3(e.data, currentPartNumber).catch(error => {
              console.error(`Chunk upload failed for part ${currentPartNumber}:`, error);
              
              Sentry.captureException(error, {
                extra: {
                  message: "Real-time chunk upload failed",
                  candidateToInterviewId: candidateToInterviewId,
                  partNumber: currentPartNumber,
                  chunkSize: e.data?.size,
                  errorDetails: error.message,
                  uploadMethod: 'realtime_chunk_upload'
                },
              });
            });
          }
        };

        mediaRecorder.start(30000); // Record in 30-second chunks (to meet S3 5MB minimum)
        videoMediaRecorderRef.current = mediaRecorder;

        mediaRecorder.onstop = async () => {
          const checkInterval = 500;
          const maxWaitTime = 90000; // 90 seconds
          let elapsedTime = 0;
          
          while (pendingUploadsRef.current.size > 0 && elapsedTime < maxWaitTime) {
            await new Promise(resolve => setTimeout(resolve, checkInterval));
            elapsedTime += checkInterval;
          }
          
          if (pendingUploadsRef.current.size > 0) {
            await fallbackToTraditionalUpload('upload_timeout');
            return;
          }
          
          await new Promise(resolve => setTimeout(resolve, 5000));
          
          let multipartSuccess = false;
          const maxCompletionRetries = 3;
          
          for (let attempt = 1; attempt <= maxCompletionRetries; attempt++) {
            try {
              const finalUrl = await completeMultipartUpload();
              if (finalUrl) {
                await updateCandidateVideoUrl(finalUrl);
                setRecordedChunks([]);
                recordedChunksRef.current = [];
                multipartSuccess = true;
                return;
              }
            } catch (error) {
              console.error(`Multipart completion attempt ${attempt} failed:`, error.response?.data || error.message);
              
              const isS3ConsistencyError = error.response?.data?.includes?.('InvalidPart') || 
                                         error.response?.data?.includes?.('could not be found');
              
              if (isS3ConsistencyError && attempt < maxCompletionRetries) {
                const retryDelay = attempt * 3000;
                await new Promise(resolve => setTimeout(resolve, retryDelay));
              }
            }
          }
          
          if (!multipartSuccess) {
            await fallbackToTraditionalUpload('multipart_failed');
          }
        };

      } catch (err) {
        console.error("Error accessing media devices:", err);
      }
    }

    setIsVideoOn(!isVideoOn);
  };

  async function speakTTS(text) {
    const languageCode = candidateInfo?.companyInterview?.bilingualLanguage
      ? detectLanguageForTTS(text)
      : getGoogleTTSLanguageCode(
          candidateInfo?.companyInterview?.interviewLanguage,
        );

    try {
      const resp = await retryRequest(() =>
        axios.post(
          `${process.env.REACT_APP_API_ENDPOINT}/Chat/textToSpeech`,
          { text },
          { responseType: "blob", languageCode },
        ),
      );
      if (resp.status === 200) {
        const blob = new Blob([resp.data], { type: "audio/wav" });
        const audio = new Audio(URL.createObjectURL(blob));
        if (audioContextRef.current && audioDestinationRef.current) {
          const src = audioContextRef.current.createMediaElementSource(audio);
          src.connect(audioDestinationRef.current);
          src.connect(audioContextRef.current.destination);
        }
        await new Promise((res) => {
          audio.onended = res;
          audio.play();
        });
      }
    } catch (e) {
      console.warn("TTS failed:", e);
    }
  }

   const handleSendMessage = async (transcription) => {
    setHasError(false);

    setHistory(prevHistory => {
      const newHistory = [...prevHistory, { role: 'User', message: transcription }];    
      return newHistory;
    });

    let currentCompany = "";
    let currentRole = "";


    const combined = candidateInfo?.candidateToInterview?.currentRole || "";
    if (combined.includes(",")) {
      const parts = combined.split(",");
      currentCompany = parts[0].trim();
      currentRole = parts.slice(1).join(",").trim(); // in case role has commas
    } else {
      // Fallback: if no comma, treat last word as role, rest as company (optional heuristic)
      const tokens = combined.trim().split(" ");
      if (tokens.length > 1) {
        currentRole = tokens.slice(-1)[0];
        currentCompany = tokens.slice(0, -1).join(" ");
      } else {
        currentRole = combined;
      }
    }


    try {
      const response = await retryRequest(() => axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/database-vetting`, {
        candidateName: candidateInfo?.candidateToInterview?.name,
        userMessage: transcription,
        history: JSON.stringify([...history, { role: 'User', message: transcription }]),
        currentRole: currentRole,
        currentCompany: currentCompany
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      }));
      
      const { response: aiResponse } = response.data;

      if (aiResponse.toLowerCase().includes("end of the interview")) {
        
        const closingLines = [
          "Thanks for taking the time to update your profile today.",
          "We'll be in touch if any relevant opportunities arise.",
        ];

        for (const line of closingLines) {
          setHistory((h) => [...h, { role: "Assistant", message: line }]);
          await new Promise((r) => setTimeout(r, 100)); 
          await speakTTS(line);
          await new Promise((r) => setTimeout(r, 300));
        }

        setInterviewDone(true);
        await handleEndInterview();
        return;
      }

      setAiResponse(aiResponse);

      const audioResponse = await retryRequest(() => axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/textToSpeech`, {
        text: aiResponse,
        languageCode: 'en-US'
      }, {
        responseType: 'blob'
      }));

      if (audioResponse.status === 200) {
        const audioBlob = new Blob([audioResponse.data], { type: 'audio/wav' });
        const audioUrl = URL.createObjectURL(audioBlob);

        const audio = new Audio(audioUrl);
        audio.volume = 1.0; 
        setIsNoraSpeaking(true);

        audio.play();
        setIsNoraSpeaking(true);
        audio.onended = () => {
          setIsNoraSpeaking(false);
        };
      } else {
        setHasError(true);
        console.error('Failed to convert text to speech');
      }

      setHistory(prevHistory => [
        ...prevHistory,
        { role: 'Assistant', message: aiResponse },
      ]);

    } catch (error) {
      setHasError(true);
      console.error('Error sending message:', error);

      // Log the error to Sentry
      Sentry.captureException(error, {
        extra: {
          transcription,
          candidateName: candidateInfo?.candidateToInterview?.name,
        },
      });
    }
    setIsLoading(false);
  };   

  const getMuxUploadUrl = async () => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/createMuxUploadUrl`);
        const { uploadUrl, id } = response.data; // Extract URL and ID
        setUploadId(id); // Save uploadId in state
        return { uploadUrl, uploadId: id };
    } catch (error) {
        console.error("Failed to get Mux upload URL", error);
        throw new Error("Could not retrieve Mux upload URL");
    }
  };

  async function sendNotifications(candidateToInterviewId) {
    try {
      const form = new FormData();
      form.append("candidateToInterviewId", candidateToInterviewId);
  
      // await it so you don't fire twice
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/Chat/sendInterviewNotifications`,
        form,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
  
      console.log("sent notifications:", data.Message);
    } catch (err) {
      console.error("failed to send notifications:", err);
    }
  }

  const handleEndInterview = async () => {
    if (isVideoOn) toggleVideo(); // Stop video recording (this triggers background processing)

     // Generate feedback and let user proceed immediately
    setFeedbackLoading(true);
    
    try {
      const response = await retryRequest(() => 
        axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/generateDatabaseVettingFeedback`, {
          candidateName: candidateInfo?.candidateToInterview?.name,
          position: candidateInfo?.companyInterview?.position,
          companyName: candidateInfo?.company?.companyName,
          candidateToInterviewId: candidateInfo?.candidateToInterview?.candidateToInterviewId,
          history: JSON.stringify([...history, { role: "User", message: "last" }])
        }, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'text/plain',
          },
        })
      );

      // Vetting complete
      setFeedbackLoading(false);
      setFinished(true);
      setStarted(false);

    } catch (error) {
      console.error('Error generating feedback:', error);
      setFeedbackLoading(false);
      setFinished(true);
      setStarted(false);
    }
  };

  const startInterview = async () => {

    setStarted(true);
    setIsLoading(true);
    
    try {

      await initializeMultipartUpload();
      
      // Automatically turn on the video when starting the interview if it is off
      if (!isVideoOn) {
        await toggleVideo();
      }
      
      handleSendMessage("first");
    } catch (error) {
      console.error('Failed to start interview with multipart upload:', error);
      // Continue with interview even if multipart upload fails (fallback will handle it)
      if (!isVideoOn) {
        await toggleVideo();
      }
      handleSendMessage("first");
    }
  };

  return (
  <>
    <div>
        {started && (
        <div className="interview-title">
            <div> Profile Update with Nora </div>
        </div>
        )}
      </div>

      {!started && !finished && (
        <div className="nora-header">
          <div className="logo-container">
            <img 
              src={COMMODORE_LOGO} 
              alt={"Commodore Partners logo"} 
              style={{
                height: '40px',    
                width: 'auto',   
                objectFit: 'contain',    
              }}
            />
          </div>
        </div>
      )}

      <div className={`nora-form-2 ${started && isMobile ? 'nora-form-mobile' : ''}`}>
          {finished ? (
            <DatabaseVettingCompletedScreen 
            />
          ) : (!started && !finished) ? (
              <div className="instructionsImage2">
                  <div className="instruction-container2">
                      <h1>
                        Welcome to your Profile Update with Nora
                      </h1>
                      <p>This quick conversation will capture your career goals and preferences so we can better match you to relevant opportunities<br />It should take about 10 minutes to complete.</p>
                  </div>
                  
                  <div className="demo-link">
                      <p>Some tips before you begin</p>
                  </div>

                  <div className="instruction-cards">
                    <div className="instruction-card1">
                      <img src={InterviewCard1} alt="Interview Tutorial icon" />
                      <div className="instruction-card-title">First time meeting Nora, our <strong> AI Recruiter? </strong></div>
                      <a href="https://youtu.be/dS3S4kLVpRo" target="_blank" rel="noopener noreferrer" className="watch-tutorial-button">
                        Watch our Tutorial
                      </a>
                    </div>

                    <div className="instruction-card">
                      <img src={InterviewCard2} alt="Chrome icon" />
                      <div className="instruction-card-title">For the best experience, use a <strong> Laptop & Google Chrome. </strong></div>
                    </div>
                    
                    <div className="instruction-card">
                      <img src={InterviewCard3} alt="Quiet environment icon" />
                      <div className="instruction-card-title">Ensure you are in a <strong> quiet, noise-free </strong> environment.</div>
                    </div>
                    
                    <div className="instruction-card">
                      <img src={InterviewCard4} alt="Microphone icon" />
                      <div className="instruction-card-title">Ensure sure your <strong> audio & video permissions are enabled </strong> by the browser.</div>
                    </div>
                    
                    <div className="instruction-card">
                      <img src={InterviewCard5} alt="Recording icon" />
                      <div className="instruction-card-title">We will record this meeting and by clicking <strong> 'Start Meeting' </strong> you agree being recorded.</div>
                    </div>
                  </div>

                  <div className="interview-ready-section">
                    {!isMobile && (
                      <div className="ready-text">Are you ready?</div>
                    )}

                    <button onClick={startInterview} className="start-button2">Start Meeting</button>
                  </div>
              </div>
          )
              : (
                  <>
                      {feedbackLoading && (
                          <div className="loading-overlay">
                              <Oval color="#00BFFF" height={80} width={80} />
                              <div className="loading-text">Processing your meeting (~2 minutes)! Please don't close this page </div>
                          </div>
                      )}
                      <div className="controls-section-2">
                        <video
                        ref={videoRef}
                        autoPlay
                        muted
                        playsInline
                        className={`video2-feed ${isVideoOn ? '' : 'hidden'}`}
                      />


                          <div className="nora-timer">
                              <div> 
                                  <img src={VideoTimer} className="video-timer-styling" alt="Timer icon" />
                                  {formatTime(time)}
                              </div>
                              {/* Multipart Upload Status */}
                              {multipartSession.isInitialized && (
                                                                  <div style={{fontSize: '10px', color: '#666', marginTop: '4px'}}>
                                </div>
                              )}
                          </div>

                          <div className="controls2">
                              {(!isLoading && !isNoraSpeaking && !isInterviewDone) && (
                                  <div>
                                      <ReactMic
                                          record={record}
                                          className="mic-styling2"
                                          onStop={onStop}
                                          visualSetting="frequencyBars" />
                                  </div>
                              )}
                              <div className="action-buttons">
                                  <div className="video-container-2">
                                      <div className="video-wrapper-2">
                                          {<img className={`nora-zoom ${isNoraSpeaking ? "nora-speaking" : ""}`}
                                          src={NoraZoom} alt="Video of Nora" />}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="transcript-container">
                          <div className="transcript-label">Live Transcript</div>
                          <div className="transcript-divider"></div>
                          <div className="message-history">
                              {history.map((msg, index) => (
                                  msg.message !== "first" && msg.message !== "last" && (
                                      <div key={index} className={`message ${msg.role}`}>
                                          {msg.message}
                                      </div>
                                  )
                              ))}
                              {hasError && (
                                  <div className="error-message">
                                      <img src={ErrorIcon} alt="Error Icon" className="error-icon" />
                                      <span>Oops, we couldn't capture your speech. Please try recording again.</span>
                                  </div>
                              )}
                              {isLoading && (
                                  <div className="">
                                      <Oval color="#00BFFF" height={20} width={20} />
                                      <span>Nora is thinking...</span>
                                  </div>
                              )}
                              <div ref={messageEndRef} />
                          </div>
                      </div>
                  </>
              )}
        </div>
        {showEndModal && (
          <div className="endInterviewOverlay">
            <div className="endInterviewContent">
              <h2>Are you sure you want to end this interview?</h2>
              <div className="modal-buttons">
                <button onClick={handleConfirmEnd} className="modal-confirm-button">Yes, Stop</button>
                <button onClick={handleCancelEnd} className="modal-cancel-button">No, Resume</button>
              </div>
            </div>
          </div>
        )}
        {started && (
          <div className="interview-controls">
            <button 
              disabled={(!record && (isLoading || isNoraSpeaking || isInterviewDone))} 
              onClick={record ? stopRecording : startRecording}
              type="button"
              className={`startAnsweringBtn ${record ? 'stop-recording' : ''} ${(!record && (isLoading || isNoraSpeaking || isInterviewDone)) ? 'disabled' : ''}`}
            >
              {record ? 'Stop Answering' : 'Start Answering'}
            </button>
            <button onClick={handleEndInterviewClick} type="button" className="endInterviewBtn2">End Interview</button>
          </div>
        )}
    </>
  );
}

export default DatabaseVettingScreen;